module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 var cls = changeClass(value, value*(o+100)/100.0); ;
__p += '\n<div class="search-tip ' +
((__t = ( cls )) == null ? '' : __t) +
' arrow arrow-left">\n  <div class="widget-popover fade in bottom arrow arrow-left">\n    <div class="widget-popover-title">\n        <span>' +
((__t = ( c.slice(2) )) == null ? '' : __t) +
'</span>\n        <h2 class="item-title">' +
((__t = ( n )) == null ? '' : __t) +
'</h2>\n    </div>\n    <div id="search-tip" class="widget-popover-content" data-code="' +
((__t = ( c )) == null ? '' : __t) +
'">\n      <div class="widget-popover-sums">\n        <span class="approved">\n            ' +
((__t = ( format_full_number( value*1000 ) )) == null ? '' : __t) +
' ₪\n        </span>\n      </div>\n    </div>\n  </div>\n</div>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/searchbar-tooltip.html
// module id = 140
// module chunks = 0